export default __webpack_public_path__ + "static/media/comment-plus.2d7e624d.svg";